import React from "react";
import { useNavigate } from "react-router-dom";
import HeaderComponent from "components/card/HeaderComponent";
import {
  Users,
  DollarSign,
  Clock,
  Calendar,
  TrendingUp,
  GraduationCap,
  Award,
  Eye,
  Download,
  Trash2,
} from "lucide-react";
import { Button } from "antd";

const iconMap = {
  users: Users,
  "dollar-sign": DollarSign,
  clock: Clock,
  "trending-up": TrendingUp,
  "graduation-cap": GraduationCap,
  award: Award,
};

function ReportCard({ card, onDelete, generatedReports }) {
  const Icon = iconMap[card.icon];
  const navigate = useNavigate();

  return (
    <div className="flex items-start gap-3 p-3 report card-select rounded-xl border-2 transition-all overflow-hidden hover:border-red-300 hover:shadow-md">
      <div className={`p-2.5 shadow-md !rounded-2xl icon-style ${card.title.toLowerCase().replace(/\s+/g, "-")}`}>
        {Icon && <Icon className="w-5 h-5 text-white" />}
      </div>

      <div className="flex-1 space-y-2 mb-3">
        <h4 className="font-semibold text-[14px]">{card.title}</h4>
        <p className="text-xs text-gray-400">Report ID: {card.reportId}</p>

        <div className="flex gap-3">
          <span className="text-[9px] flex items-center gap-1">
            <Calendar className="w-3 h-3" />
            {card.dateRange}
          </span>
          <span className="text-[9px] flex items-center gap-1">
            <Clock className="w-3 h-3" />
            {card.generatedAt}
          </span>
        </div>

        <div className="flex items-center gap-2">
          <Button
            onClick={() =>
              navigate(`/console/generate-report/${card.reportId}/view`, {
                state: { generatedReports } 
              })
            }
            className="flex items-center gap-1 h-8 rounded-xl px-3 border-2 text-sm font-medium hover:!bg-gray-50"
          >
            <Eye className="w-4 h-4" /> View
          </Button>

          <Button className="flex items-center gap-1 h-8 rounded-xl px-3 border-2 text-sm font-medium hover:!bg-gray-50">
            <Download className="w-4 h-4" /> Export
          </Button>
          <Button
            onClick={onDelete}
            className="border-none flex items-center gap-1 h-8 px-3 text-sm font-medium hover:!bg-red-50 text-red-600"
          >
            <Trash2 className="w-4 h-4" /> Delete
          </Button>
        </div>
      </div>

      <p
        className={`text-xs font-semibold px-2 py-0.5 rounded-xl text-white ${
          card.status === "generating"
            ? "bg-gradient-to-r from-yellow-500 to-orange-500"
            : "bg-gradient-to-r from-green-500 to-emerald-500"
        }`}
      >
        {card.status === "generating" ? "Generating..." : "Completed"}
      </p>
    </div>
  );
}

export default function ReportHistory({ analyticsCards = [], onDeleteReport }) {
  return (
    <div className="col-span-2">
      <HeaderComponent
        title="Generated Reports"
        description={`${analyticsCards.length} reports generated`}
        descriptionClass="text-sm text-gray-700"
        bgcolor="bg-gradient-to-br from-red-50 to-orange-50"
        colorTheme="gradient-purple"
      >
        <div className="grid grid-cols-1 gap-4 max-h-[480px] overflow-y-auto">
          {analyticsCards.map((card) => (
            <ReportCard
              key={card.reportId}
              card={card}
              onDelete={() => onDeleteReport(card.reportId)}
            />
          ))}
        </div>
      </HeaderComponent>
    </div>
  );
}
